export default "__VITE_ASSET__Dl$LOsrC__"